export default "__VITE_ASSET__DR8SW_Ur__"